/**
 * Product ID constants
 * Centralized location for product IDs used throughout the application
 */

export const MASTERCLASS_TRIAL_PRODUCT_ID = 24665
export const MASTERCLASS_SUBSCRIPTION_PRODUCT_ID = 19483
export const DONATION_PRODUCT_ID = 291
export const GIFT_VOUCHER_PRODUCT_ID = 1161
